import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

interface CategoryProperties {
    categoryShowImageOnPLP: boolean;
    contentTop: string;
    gridview: boolean;
    productListGridAttributeColumns: string;
}

export type CustomCategoryPropsState = Readonly<CategoryProperties>;

export const initialCategoryPropsState: CustomCategoryPropsState = {
    categoryShowImageOnPLP: false,
    contentTop: "",
    gridview: false,
    productListGridAttributeColumns: "",
};

export const customCategoryPropsReducer = createTypedReducer(initialCategoryPropsState, {
    "Custom/CategoryProps/GetCategoryPropertiesCompleted": (
        draft: Draft<CustomCategoryPropsState>,
        action: { categoryProperties: CategoryProperties },
    ) => {
        return {
            ...draft,
            ...action.categoryProperties,
        };
    },

    "Custom/CategoryProps/ClearCategoryProperties": (draft: Draft<CustomCategoryPropsState>) => {
        return initialCategoryPropsState;
    },
});
